// extracted by mini-css-extract-plugin
export default {"overlay":"style_overlay__QJFFh","modal":"style_modal__3Z7Qd","header":"style_header__JzOZk","closeButton":"style_closeButton__kBVB7","content":"style_content__A4VtE"};